import { Badge, Button, Stack } from '@mui/material'
import {
  GridRowSelectionModel,
  GridToolbarContainer,
} from '@mui/x-data-grid-pro'
import { AddShoppingCart, ShoppingCart } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { stackGap } from '../../../Constants&Theme/Spacing'

function SaleItemDGToolbar({
  selection,
  setCart,
  clear,
  cart,
}: {
  selection: GridRowSelectionModel
  setCart: any
  clear: any
  cart: number[]
}) {
  const navigate = useNavigate()
  return (
    <GridToolbarContainer sx={{ width: 1, p: 1 }}>
      <Stack
        direction={'row'}
        gap={stackGap.row}
        width={1}
        display={'flex'}
      >
        {/*<GridToolbarDensitySelector />*/}
        <Button
          sx={{ ml: 'auto' }}
          variant={'outlined'}
          startIcon={<AddShoppingCart />}
          onClick={() => {
            setCart((c: any[]) => c.concat(selection))
            clear()
          }}
        >
          Add to Cart
        </Button>
        <Badge
          badgeContent={cart.length}
          color="primary"
        >
          <Button
            variant={'outlined'}
            startIcon={<ShoppingCart />}
            disabled={cart.length < 1}
            onClick={() =>
              navigate('cart', {
                state: {
                  cart: cart,
                },
              })
            }
          >
            View Cart
          </Button>
        </Badge>
      </Stack>
    </GridToolbarContainer>
  )
}

export default SaleItemDGToolbar
